/**
 * Typed event emitter for engine → React communication.
 * No external dependencies.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class EventEmitter<Events extends Record<string, (...args: any[]) => void>> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private listeners = new Map<keyof Events, Set<(...args: any[]) => void>>();

  on<K extends keyof Events>(event: K, callback: Events[K]): void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.listeners.get(event)!.add(callback as (...args: any[]) => void);
  }

  off<K extends keyof Events>(event: K, callback: Events[K]): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.listeners.get(event)?.delete(callback as (...args: any[]) => void);
  }

  protected emit<K extends keyof Events>(event: K, ...args: Parameters<Events[K]>): void {
    const set = this.listeners.get(event);
    if (!set) return;
    for (const cb of set) {
      (cb as (...a: Parameters<Events[K]>) => void)(...args);
    }
  }

  removeAllListeners(): void {
    this.listeners.clear();
  }
}
